import {httpRequest, endpoints} from "../network/hitag.client";
import router from '../../router/index.js';
import * as _ from "lodash";
import crud, {baseActions, baseGetters, baseMutations, baseState} from "./baseStore";

function state(){
    return {
        ...baseState(),
    }
}

function getters(){
    return {
        ...baseGetters()
    }
}

function mutations(){
    return {
        ...baseMutations()
    }
}

function actions(){
    return {
        ...baseActions('inspections')
    }
}

function inspectionsModule()
{
    return {
        namespaced: true,
        state: state(),
        getters: getters(),
        mutations: mutations(),
        actions: actions()
    }
}
export default inspectionsModule;
